import { useState } from "react";
import DeleteModal from "../../../../common/DeleteModal";
import { useSelector } from "react-redux";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import { Translate } from "../../../../Enums/Tranlate";
import QrCodeGroupingService from "../../../../../services/QrCodeGroupingService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({ item, index, setShouldUpdate, setItem, setAddModal }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const qrCodeGroupingService = new QrCodeGroupingService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.name}</td>
			<td>{lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar}</td>
			<td>{item?.quantity}</td>
			<td>
				{Number(item?.price)?.toFixed(3)} {Translate[lang].kwd}
			</td>
			<td>
				{
					Translate[lang][
						item?.price_per === "event_schedule"
							? "one_time_price"
							: item?.price_per
					]
				}
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("qr_code_grouping") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("qr_code_grouping") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={qrCodeGroupingService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
